import React from 'react';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContentWithArrow, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';

type TruncatedNameProps = {
  name: React.ReactNode;
  fullName: string;
  children?: React.ReactNode;
  className?: string;
};

export const TruncatedName = ({ name, fullName, children, className }: TruncatedNameProps) => {
  const nameRef = React.useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  const updateIsTruncated = React.useCallback(() => {
    const element = nameRef.current;
    if (element) {
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
  }, []);

  return (
    <div className={cn('flex min-w-0 items-center gap-[6px]', className)}>
      <Tooltip>
        <TooltipTrigger asChild disabled={!isTruncated} onMouseEnter={updateIsTruncated} onFocus={updateIsTruncated}>
          <div ref={nameRef} className="truncate">
            {name}
          </div>
        </TooltipTrigger>
        {isTruncated && (
          <TooltipPortal>
            <TooltipContentWithArrow>{fullName}</TooltipContentWithArrow>
          </TooltipPortal>
        )}
      </Tooltip>
      {children}
    </div>
  );
};
